<template>
  <basic-container class="fee-return-dia">
    <el-dialog
      :title="title"
      :visible.sync="showDialogForm"
      :modal-append-to-body="false"
      width="64%"
      @closed="handleClose"
    >
      <div>
        <el-form
          ref="dialogForm"
          :model="dialogForm.feeReturn"
          label-width="120px"
          margin-top="10px"
          margin-right="5px"
          :rules="rules"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="收费单号">
                <el-input v-model="dialogForm.feeData.paybillNo" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="房产">
                <el-input v-model="dialogForm.feeData.roomName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="住户">
                <el-input v-model="dialogForm.feeData.payManName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="缴费时间">
                <el-input v-model="dialogForm.feeData.payTime" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="收款人">
                <el-input v-model="dialogForm.feeData.cashierName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="收款方式">
                <el-select
                  v-model="dialogForm.feeData.payType"
                  style="width: 100%"
                  :disabled="true"
                >
                  <el-option
                    style="padding-left: 10px"
                    v-for="item in payTypeList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退款状态">
                <el-select
                  v-model="dialogForm.feeData.payStatus"
                  style="width: 100%"
                  :disabled="true"
                >
                  <el-option
                    style="padding-left: 10px"
                    v-for="item in payStatusList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-divider content-position="left"><strong>收费明细</strong></el-divider>
            </el-col>
          </el-row>
          <el-row>
            <avue-crud
              ref="crud"
              :data="dialogForm.feeListData"
              :option="billOption"
              v-model="detailForm"
            >
              <!--<template slot-scope="{ row }" slot="currentReturnAmount">
                <el-input
                  v-model="row.currentReturnAmount"
                  :ref="'return' + row.$index"
                  @blur="afterInputReturnAmount(row)"
                  :class="row.applyInputClassName"
                  :disabled="row.availableAmount <= 0"
                ></el-input>
              </template>-->
            </avue-crud>
          </el-row>
          <el-row style="margin-top: 20px">
            <el-col :span="6">
              <el-form-item label="申请退款方式" prop="returnChannel">
                <el-select
                  v-model="dialogForm.feeReturn.returnChannel"
                  style="width: 100%"
                  :disabled="true"
                >
                  <el-option
                    style="padding-left: 10px"
                    v-for="item in returnChannelList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="本次总退费(元)" class="self-label">
                <el-input
                  type="number"
                  v-model="dialogForm.feeReturn.totalReturnAmount"
                  class="self-input-red"
                  ref="backingAmountInput"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="退款原因说明" prop="returnRemark">
                <el-input
                  type="textarea"
                  v-model="dialogForm.feeReturn.returnRemark"
                  :disabled="true"
                  :rows="1"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="审批意见" prop="auditStatus">
                <el-select v-model="dialogForm.feeReturn.auditStatus" style="width: 100%">
                  <el-option
                    style="padding-left: 10px"
                    v-for="item in auditTypeList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="审批说明" prop="auditRemark">
                <el-input
                  type="textarea"
                  :rows="1"
                  autosize
                  v-model="dialogForm.feeReturn.auditRemark"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="text-align:center;">
              <el-button
                type="primary"
                :icon="submitBtnIcon"
                @click.native.prevent="auditSubmit"
                style="width: 80px; height: 36px"
                >确认{{ counterLeft }}
              </el-button>
              <el-button
                icon="el-icon-close"
                @click="handleClose()"
                style="width: 80px; height: 36px; margin-left: 20px"
                >取消</el-button
              >
          </el-row>
        </el-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import { getDictionaryWithIntKey } from '../../../api/common';
import { getFeePayList, auditFeeReturn, auditTwice } from '@/api/v4ward/feereturn/feereturn-audit';

export default {
  name: 'feereturn-audit.vue',
  data() {
    return {
      submitBtnIcon: 'el-icon-check',
      title: '',
      applyAmount: '0',
      showDialogForm: false,
      payTypeList: [],
      returnChannelList: [],
      returnApplyList: [],
      payStatusList: [],
      auditTypeList: [
        { key: 1, value: '同意' },
        { key: 2, value: '拒绝' },
      ],
      dialogForm: {
        feeData: {},
        feeListData: [],
        feeReturn: {
          auditStatus: 1,
          auditRemark: '',
          totalReturnAmount: ''
        },
      },
      rules: {
        auditRemark: [{ required: true, message: '请选择', trigger: 'blur' }],
        auditStatus: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      billOption: {
        page: false,
        align: 'center',
        menuAlign: 'center',
        // maxHeight: 200,
        menu: false,
        addBtn: false,
        refreshBtn: false,
        columnBtn: false,
        index: true,
        indexLabel: '序号',
        selection: false,
        stripe: true,
        border: true,
        tip: false,
        showSummary: true,
        sumColumnList: [
          {
            name: 'payAmount',
            type: 'sum',
          },
          {
            name: 'returnedAmount',
            type: 'sum',
          },
          {
            name: 'availableAmount',
            type: 'sum',
          },
          {
            name: 'currentReturnAmount',
            type: 'sum',
          },
        ],
        column: [
          {
            label: '收费类型',
            prop: 'paySort',
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=pay_sort',
          },
          {
            label: '费用名称',
            prop: 'itemsetName',
            width: 230,
          },
          {
            label: '周期编码',
            prop: 'billcycleNo',
            width: 80,
          },
          {
            label: '账单起期',
            prop: 'billStartDate',
            type: 'date',
            format: 'yyyy-MM-dd',
            width: 100,
          },
          {
            label: '账单止期',
            prop: 'billEndDate',
            type: 'date',
            format: 'yyyy-MM-dd',
            width: 100,
          },
          {
            label: '缴费金额',
            prop: 'payAmount',
          },
          {
            label: '已退金额',
            prop: 'returnedAmount',
            hide: true,
          },
          {
            label: '可退金额',
            prop: 'availableAmount',
            hide: true,
          },
          {
            label: '本次退费',
            prop: 'currentReturnAmount',
            // dataType: 'number',
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.initAllSelectionList();
  },
  methods: {
    enableSubmit() {
      this.submitBtnIcon = 'el-icon-check';
    },
    auditSubmit() {
      this.$refs.dialogForm.validate((valid) => {
        var t1 = window.setTimeout(this.enableSubmit, 15000);
        this.submitBtnIcon = 'el-icon-loading';
        if (valid) {
          let param = {
            feeBackId: this.dialogForm.feeReturn.id,
            auditStatus: this.dialogForm.feeReturn.auditStatus,
            auditRemark: this.dialogForm.feeReturn.auditRemark,
            feeData:this.dialogForm.feeData,
            feeListData:this.dialogForm.feeListData,
          };
          auditFeeReturn(param)
            .then(() => {
              this.$message.success('审核成功！');
              this.submitBtnIcon = 'el-icon-check';
              this.$emit('closeAuditForm','66666666');
              this.handleClose();
            })
            .catch((err) => {
              console.log(err);
              if(err.msg == '收费主表信息中没有商户订单号信息，不能原路退还'){
                this.$confirm('该订单只能进行人工退款，确认后只修改订单信息', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                }).then(()=>{
                  auditTwice(param).then(()=>{
                    this.$message.success('审核成功！');
                    this.submitBtnIcon = 'el-icon-check';
                    this.$emit('closeAuditForm','66666666');
                    this.handleClose();
                  })
                }).catch((err)=>{

                })
              }
              this.submitBtnIcon = 'el-icon-check';
            });
        } else {
          this.$message.warning('数据不合法！');
          this.submitBtnIcon = 'el-icon-check';
        }
        window.clearTimeout(t1);
      });
    },
    openDialogForm(title, id) {
      this.title = title;
      this.showDialogForm = true;
      getFeePayList(id).then((data) => {
        this.dialogForm = data.data;
        this.dialogForm.feeReturn.auditStatus = 1;
        this.calTotalReturnAmount();
      });
    },
    initAllSelectionList() {
      getDictionaryWithIntKey('pay_type').then((data) => {
        this.payTypeList = data.data;
      });
      getDictionaryWithIntKey('return_channel').then((data) => {
        this.returnChannelList = data.data;
      });
      getDictionaryWithIntKey('return_apply').then((data) => {
        this.returnApplyList = data.data;
      });
      getDictionaryWithIntKey('pay_status').then((data) => {
        this.payStatusList = data.data;
      });
    },
    handleClose() {
      this.title = '';
      this.applyAmount = '0';
      this.showDialogForm = false;
      this.dialogForm = {
        feeData: {},
        feeListData: [],
        feeReturn: {},
      };
    },
    calTotalReturnAmount() {
      setTimeout(() => {
        this.applyAmount = this.$refs.crud.sumsList[9].split(':')[1];
      });
    }
  },
};
</script>

<style scoped>
.el-divider--horizontal {
  margin: 8px 0;
  background: 0 0;
  border-top: 1px solid #e8eaec;
}

.el-dialog__body .el-col {
  margin-bottom: 2px;
  margin-top: 2px;
}
.fee-return-dia .el-dialog__body {
  padding: 10px 60px 20px 50px;
}
.money-text-align .el-input--small .el-input__inner {
  text-align: center;
}
.avue-crud__menu {
  min-height: 10px;
}
.self-label .el-form-item__label {
  font-size: 14px;
}
.self-input-red input.el-input__inner {
  color: red;
  font-size: 20px;
  background-color: #f3f3f3;
}
.avue-crud__pagination {
  position: relative;
  height: 0;
  margin-top: 0;
  margin-bottom: 0 !important;
  padding: 0 0;
}
</style>
